<div class="w-full h-full">
<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

  <p-toolbar>
    <ng-template #start>
      <div class="flex gap-2">
        <p-selectButton [options]="resultsView" visible="true"
          [(ngModel)]="selectedResultsView" (onChange)="resultsViewToggle($event)"
          [allowEmpty]="false">
        </p-selectButton>

        <p-selectButton [options]="resultsDisplay" [(ngModel)]="selectedResultDisplay"
          (onChange)="onSelectedResultDisplayUpdated($event)" [allowEmpty]="false">
        </p-selectButton>

        @if (selectedResultDisplay === 'plot') {
          <p-selectButton [options]="depthView"
            [(ngModel)]="selectedDepthView" (onChange)="onSelectedDepthViewUpdated($event)"
            [allowEmpty]="false">
          </p-selectButton>
        }
      </div>
    </ng-template>
  </p-toolbar>

  @if (selectedResultDisplay === 'plot') {
    <app-single-load-plot
      [yAxisTitle]="yAxisTitle" [xAxisTitle]="xAxisTitle" [columnDefs]="columnDefs" [data]="results"
      [selectedDepthView]="selectedDepthView" [loadCaseResultField]="selectedLoadCase"
      [depthUnit]="depthUnit" [plotName]="plotName" [plotTitle]="'Press & Temp'"
      [singleLoadPlotStore]="pressureResultsStore">
    </app-single-load-plot>
  }

  <app-single-load-grid
    [hidden]="selectedResultDisplay !== 'grid'"
    [rowData]="results" [columnDefinitions]="columnDefinitions" tableName="Press & Temp"
    gridName="Press & Temp"
    >
  </app-single-load-grid>

  <p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i>
    <label>{{ errorMsg }}</label>
    <br />
    <br />
  </p-dialog>

   @if (displacementResults != null) {
    <app-perivis-validation [errors]="displacementResults[0]?.errors" />
   }

</app-tool-loader>
</div>